import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const sectionWrapper: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  marginTop: toPx(sharedStyles.Spacings.NORMAL),
}

export const sectionTitle: React.CSSProperties = {
  ...sharedStyles.text,
  fontSize: toPx(sharedStyles.FontSizes.SMALL),
  lineHeight: 1.4,
  color: sharedStyles.Colors.SECONDARY,
}

export const contentWrapper: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
}

export const separator: React.CSSProperties = {
  marginTop: toPx(sharedStyles.Spacings.NORMAL),
  borderTop: `${toPx(1)} solid ${sharedStyles.Colors.Tints.NEUTRAL[4]}`,
}
